import { FC } from 'react';
import type { DashboardPresetEditor } from '../../model/useDashboardPresetEditor';
import type { CustomChartPanelFilters } from '../DashboardPresetGrid/CustomChartCard';
import { DashboardEditGrid } from './DashboardEditGrid';

type Props = {
  /** Состояние и действия режима редактирования */
  editor: DashboardPresetEditor;
  /** Фильтры панели страницы: правящийся дашборд наполняется теми же данными, что и применённый */
  filters: CustomChartPanelFilters;
};

/**
 * Правка дашборда на самой странице: сетка правящегося дашборда, на которой правятся и свойства
 * каждой диаграммы. Показывается вместо дашборда — стандартного или применённого пресета.
 *
 * Своей полосы у режима нет: название правящегося дашборда, сохранение и отказ от правок стоят в
 * заголовке страницы — там, где пользователь ждёт их по прочим разделам управления.
 */
export const DashboardEditSection: FC<Props> = ({ editor, filters }) => {
  const { draft } = editor;
  if (!draft) return null;

  return (
    <DashboardEditGrid
      charts={draft.charts}
      filters={filters}
      expandedChartId={editor.expandedChartId}
      onAddChart={editor.addChart}
      onToggleProperties={editor.toggleChartProperties}
      onKeepDescription={editor.keepChartDescription}
      onResolveChart={editor.applyChartValues}
      onApplyProperties={editor.applyChartProperties}
      onRemoveChart={editor.removeChart}
      onMoveChart={editor.moveChart}
      onResizeChart={editor.resizeChart}
    />
  );
};
